import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

const findPaymentReconciliations = createAsyncThunk(
  "paymentNoticeDetail/findPaymentReconciliations",
  async (id: number, { rejectWithValue }) => {
    try {
      const url = new URL(`${api.baseURL}paymentReconciliation`);
      url.searchParams.append(
        "where",
        JSON.stringify({
          payment: id.toString(),
          paymentType: { "!=": 0 },
        }),
      );
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      let response = await fetch(url.toJSON(), {
        method: "GET",
        headers: headers,
      });
      if (!response.ok) {
        throw response.statusText;
      }
      let data = await response.json();
      return data.sort((a: any, b: any) =>
        parseInt(a.invoice.identifier) > parseInt(b.invoice.identifier) ? 1 : -1,
      );
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export default findPaymentReconciliations;
